// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__25B2K","inputDescription":"styles_inputDescription__YdoGP"};